module.exports = __webpack_public_path__ + "img/gold.752db520.png";